import { defineMessages } from "react-intl";

export const messages = defineMessages({
    loadMoreDeliveries: {
        id: "deliveries.general.load-more-deliveries",
        defaultMessage: "Load more deliveries",
    },
    filterTypes: {
        id: "deliveries.settings.type-filter",
        defaultMessage: "Filter by type",
    },
    filterStatusTypes: {
        id: "deliveries.settings.status-type-filter",
        defaultMessage: "Filter by status type",
    },
    // Delivery types
    deliveryTypeInsert: {
        id: "deliveries.type.insert",
        defaultMessage: "Full new",
    },
    deliveryTypeFullUpdate: {
        id: "deliveries.type.full-update",
        defaultMessage: "Full update",
    },
    deliveryTypeFullTakedown: {
        id: "deliveries.type.full-takedown",
        defaultMessage: "Full takedown",
    },
    deliveryTypeUpdateTracks: {
        id: "deliveries.type.update-tracks",
        defaultMessage: "Update tracks",
    },
    deliveryTypeUpdateMetadata: {
        id: "deliveries.type.update-metadata",
        defaultMessage: "Update metadata",
    },
    deliveryTypeUpdateDeal: {
        id: "deliveries.type.update-deal",
        defaultMessage: "Update deal",
    },
    // Delivery status types
    deliveryStatusTypeSelected: {
    id: "deliveries.status_type.selected",
        defaultMessage: "Selected",
    },
    deliveryStatusTypeScheduled: {
        id: "deliveries.status_type.scheduled-delivery",
        defaultMessage: "Scheduled delivery",
    },
    deliveryStatusTypeInProgress: {
        id: "deliveries.status_type.delivery-in-progress",
        defaultMessage: "Delivery in progress",
    },
    deliveryStatusTypeDelivered: {
        id: "deliveries.status_type.delivered",
        defaultMessage: "Delivered",
    },
    deliveryStatusTypeError: {
        id: "deliveries.status_type.error",
        defaultMessage: "Error",
    },
    deliveryStatusTypeCancelled: {
        id: "deliveries.status_type.cancelled",
        defaultMessage: "Cancelled",
    },
    deliveryStatusTypeNotAvailable: {
        id: "deliveries.status_type.not-available",
        defaultMessage: "Not available",
    },
    deliveryStatusTypeAvailable: {
        id: "deliveries.status_type.available",
        defaultMessage: "Available",
    },
    // Delivery entity
    deliveryEntitySingular: {
        id: "deliveries.delivery.entity_singular",
        defaultMessage: "Delivery",
    },
    deliveryEntityPlural: {
        id: "deliveries.delivery.entity_plural",
        defaultMessage: "Deliveries",
    },
    deliveryEntityDefiniteArticle: {
        id: "deliveries.delivery.entity_definite_article",
        defaultMessage: "the delivery",
    },
    deliveryEntityDemonstrative: {
        id: "deliveries.delivery.entity_demonstrative",
        defaultMessage: "this delivery",
    },
    deliveryEntityIndefiniteArticle: {
        id: "deliveries.delivery.entity_indefinite_article",
        defaultMessage: "a delivery",
    },
    deliveryColumnAlbum: {
        id: "deliveries.delivery.columns.album",
        defaultMessage: "Album",
    },
    deliveryColumnUpc: {
        id: "deliveries.delivery.columns.upc",
        defaultMessage: "UPC/EAN",
    },
    deliveryColumnDsp: {
        id: "deliveries.delivery.columns.dsp",
        defaultMessage: "DSP",
    },
    deliveryColumnType: {
        id: "deliveries.delivery.columns.type",
        defaultMessage: "Type",
    },
    deliveryColumnStatus: {
        id: "deliveries.delivery.columns.status",
        defaultMessage: "Status",
    },
    deliveryColumnBatch: {
        id: "deliveries.delivery.columns.batch",
        defaultMessage: "Batch",
    },
    deliveryColumnCreatedAt: {
        id: "deliveries.delivery.columns.created_at",
        defaultMessage: "Created",
    },
    deliveryColumnUpdatedAt: {
        id: "deliveries.delivery.columns.updated_at",
        defaultMessage: "Updated",
    },
    // Status entity
    statusColumnType: {
        id: "deliveries.status.columns.type",
        defaultMessage: "Type",
    },
    statusColumnOccurredAt: {
        id: "deliveries.status.columns.occurred_at",
        defaultMessage: "Occurred",
    },
    // Batch entity
    batchColumnName: {
        id: "deliveries.batch.columns.name",
        defaultMessage: "Batch name",
    },
    batchColumnFileStructure: {
        id: "deliveries.batch.columns.file_structure",
        defaultMessage: "Files",
    },
});
